import { useEffect, useState } from 'react';
import CustomTabs, { TabPanels } from '../../components/tabs/Tabs';
import { TABS_CONFIG } from './config/tabsConfig';
import './soporteHCContent.scss';

export const SoporteHCContent = ({ setHeaderContent }) => {
    const [currentTabIndex, setCurrentTabIndex] = useState(0);

    const handleChangeTab = (tabIndex) => {
        setCurrentTabIndex(tabIndex);
    };

    useEffect(() => {
        setHeaderContent(() => (
            <CustomTabs
                tabs={TABS_CONFIG}
                currentTabIndex={currentTabIndex}
                initialTabIndex={0}
                handleChangeTab={handleChangeTab}
                keepEverythingMounted
            />
        ))
    }, [
        setHeaderContent,
        currentTabIndex,
    ]);

    return (
        <div>
            <TabPanels
                tabs={TABS_CONFIG}
                initialTabIndex={0}
                currentTabIndex={currentTabIndex}
            />
        </div>
    )
}